import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DEFAULT_LANG } from '@shared/utils/locales';

export const translationsPreloadInitializer: EnvironmentProviders = provideAppInitializer(() => {
  const translate = inject(TranslateService);
  return translate.use(DEFAULT_LANG);
});
